import { signal, type Provider } from '@angular/core';
import { PracticeSetupWizardStore } from '../components/setup-wizard/setup-wizard.store';

function buildMockPracticeSetupWizardStoreDefaults(): Partial<PracticeSetupWizardStore> {
  return {
    wizard: signal(undefined),
    steps: signal([]),
    stepsByCategory: signal(new Map()),
    region: signal(undefined),
    loading: signal(false),
    mutating: signal(false),
    error: signal(undefined),
    regionFilteredSteps: signal([]),
    completionPercentage: signal(0),
    categories: signal([]),
    loadWizard: jest.fn(),
    loadWizardByRef: jest.fn(),
    completeStep: jest.fn(),
    reopenStep: jest.fn(),
    assignStep: jest.fn(),
    trackVisit: jest.fn(),
    dismissWizard: jest.fn(),
    resetState: jest.fn(),
    canComplete: jest.fn(() => signal(false)),
  };
}

export function MockPracticeSetupWizardStoreProvider(
  overrides: Partial<PracticeSetupWizardStore> = {}
): Provider {
  return {
    provide: PracticeSetupWizardStore,
    useValue: {
      ...buildMockPracticeSetupWizardStoreDefaults(),
      ...overrides,
    },
  };
}
